import { BasicModel } from "../basic/basic.model";
import { AgenceModel } from "../rsa/agence.model";

export class AgenceLinkedModel extends BasicModel{
    // max 9
    idAgence: number = -1;
    agence: AgenceModel;
}
